import { useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import FetchUtil from "../utils/FetchUtil";
import { scrollToTop } from "../utils/helper.js";
import { ddStyles } from "../utils/CommonStyles.js";

let partnerOptions = [];

function PartnerModal({ t, companyList, supplierCompanyId, setShow, isNew, formdata, refetch, editComplete }) {
    const [error, setError] = useState("");
    const [formErrors, setFormErrors] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const userCtx = useContext(UserContext);
    const navigate = useNavigate();
    const [partnerSelected, setPartnerSelected] = useState({ name: "companyId", label: "", value: formdata.clientCompanyId });
    const [partnerLoaded, setPartnerLoaded] = useState(false);

    const submitText = t("page.submit");
    const closeText = t("page.close");
    const today = new Date().toISOString().split("T")[0];
    const [rawProduct, setRawProduct] = useState(formdata.rawProduct);
    const [finishedProduct, setFinishedProduct] = useState(formdata.finishedProduct);
    const [addUpdateSurvey, setAddUpdateSurvey] = useState(formdata.addUpdateSurvey);
    const [canShareBrokerWithBuyer, setCanShareBrokerWithBuyer] = useState(formdata.canShareBrokerWithBuyer);
    const [partnerNumber, setPartnerNumber] = useState(formdata.partnerNumber);

    useEffect(() => {
        setPartnerValues();
        scrollToTop();
    }, []);

    function setPartnerValues() {
        let partnerValue = {};
        partnerOptions = [];
        if (companyList && companyList.length > 0) {
            companyList.map((company, index) => {
                if (company.companyId !== supplierCompanyId) {
                    partnerValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                    partnerValue.value = company.companyId;
                    partnerOptions.push(partnerValue);
                    partnerValue = {};
                }
            });
            setPartnerLoaded(true);
        }
    }

    const partnerHandler = (selectedOption, action) => {
        let partnerId = selectedOption ? selectedOption.value : 0;
        let partnerName = selectedOption ? selectedOption.label : "";
        setPartnerSelected({ ...partnerSelected, label: partnerName, value: partnerId });
    }
    const valueHandler = (e) => {
        const { name, value } = e.target;
        if (typeof value === 'undefined') {
            value = "";
        }
        setDates({ ...dates, [name]: value });
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        if (name.startsWith("addUpdateSurvey")) {
            setAddUpdateSurvey(event.target.checked);
        } else if (name.startsWith("canShareBrokerWithBuyer")) {
            setCanShareBrokerWithBuyer(event.target.checked);
        } else if (name.startsWith("rawProduct")) {
            setRawProduct(event.target.checked);
        } else if (name.startsWith("finishedProduct")) {
            setFinishedProduct(event.target.checked);
        }
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmit(true);
        let errors = validateFields();
        setFormErrors(errors);
        if (!errors || errors.length === 0) {
            addPartner();
        } else {
            setIsSubmit(false);
        }

    };
    const validateFields = () => {
        const errors = [];
        let partnerNameRegEx = /^[a-zA-Z0-9_-]+$/;
        if (!partnerSelected.value || partnerSelected.value === 0) {
            errors.push(t("error.partnerReqd"));
        }
        if (partnerNumber) {
            if (!partnerNameRegEx.test(partnerNumber)) {
                errors.push(t("error.partnerNumber.invalid"));
                setPartnerNumber("");
            }
        }
        return errors;
    };
    const addPartner = () => {
        let action = 1;
        if (!isNew) {
            action = 2;
        }
        let serverParams = {
            partnershipKey: formdata.partnershipKey,
            supplierCompanyId: supplierCompanyId,
            clientCompanyId: partnerSelected.value,
            rawProduct: rawProduct,
            finishedProduct: finishedProduct,
            addUpdateSurvey: addUpdateSurvey,
            canShareBrokerWithBuyer: canShareBrokerWithBuyer,
            partnerNumber: partnerNumber,
            source: "web",
            action: action,
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdatePartner", "/Service/CompanyService/AddUpdatePartner", requestOptions, addPartnerSuccess, addPartnerFail);
        } catch (error) {
            setError(error.message);
        }
    };

    function addPartnerFail(redirect) {
        setIsSubmit(false);
        setError(t("error.companyEditFailed"));
    }
    function addPartnerSuccess(responseData) {
        setIsSubmit(false);
        let addUpdatePartnerResponse;
        if (responseData) {
            addUpdatePartnerResponse = responseData.addUpdatePartnerResponse;
            if (addUpdatePartnerResponse) {
                if (addUpdatePartnerResponse.errorCode === "0") {
                    setShow(false);
                    refetch();
                    navigate("/pages/partners");
                } else {
                    setError(t("error.error") + " " +
                        addUpdatePartnerResponse.errorMessage
                    );
                }
            }
        }
    }

    const handleClose = () => {
        setError("");
        setShow(false);
        editComplete();
    };

    return (
        <>
            {(userCtx.role === "SiteAdmin") ?
                <div className="modalContainer-sm hide-scrollbar">
                    <div className="row">
                        <div className="col mt-3">
                            {((formErrors && formErrors.length > 0) || error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {((formErrors && formErrors.length > 0)) ? (
                                        formErrors.map((errorData, index) => (
                                            <p className="message-line">{errorData}</p>
                                        ))
                                    ) : ""}
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <form
                                className="regn_form_container"
                                acceptCharset="UTF-8"
                                id="sign-up"
                                onSubmit={handleSubmit}
                            >
                                <h3>{(isNew) ? t("page.partner.add") : t("page.partner.edit")}
                                </h3>

                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.buyer")}
                                            </label>
                                            {(isNew) ? <Select
                                                name="companyId"
                                                options={partnerOptions}
                                                onChange={partnerHandler}
                                                placeholder={""}
                                                value={partnerSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="companyId-input"
                                                styles={ddStyles}
                                                isDisabled={!isNew}
                                            />
                                                : <> <h4> {formdata.clientCompanyName}</h4></>
                                            }

                                        </div>
                                        <div style={{ "display": "inline-block", "marginRight": "10px" }}>
                                            <label htmlFor="companyNumber" className="form-label">
                                                {t("page.suplrNumber")}
                                            </label>
                                            <input
                                                type="text"
                                                name="partnerNumber"
                                                id="partnerNumber"
                                                value={partnerNumber}
                                                onChange={(e) => setPartnerNumber(e.target.value)}
                                                maxLength="50"
                                                placeholder={t("page.suplrNumber")}
                                                className="form-control rounded-pill shadow-sm px-4 "
                                            />
                                        </div>
                                        <div style={{ "display": "inline-block", "marginLeft": "15px", "marginRight": "10px" }}>
                                            <label htmlFor="addUpdateSurvey" className="form-label">
                                                {t("page.survey.canadd")}
                                            </label>
                                            <input type="checkbox" className="mycheckbox"
                                                name="addUpdateSurvey"
                                                id="addUpdateSurvey"
                                                defaultChecked={true}
                                                checked={addUpdateSurvey}
                                                onChange={onResponseChange}
                                            />
                                        </div>
                                        <div style={{ "display": "inline-block", "marginLeft": "15px", "marginRight": "10px" }}>
                                            <label htmlFor="canShareBrokerWithBuyer" className="form-label">
                                                {t("page.broker.share")}
                                            </label>
                                            <input type="checkbox" className="mycheckbox"
                                                name="canShareBrokerWithBuyer"
                                                id="canShareBrokerWithBuyer"
                                                defaultChecked={true}
                                                checked={canShareBrokerWithBuyer}
                                                onChange={onResponseChange}
                                            />
                                        </div>

                                        {/* 
								<div style={{ "display": "inline-block", "marginLeft": "15px", "marginRight": "10px" }}>
									<label htmlFor="rawProduct" className="form-label">
										{t("page.prod.raw")}
									</label>
									<input type="checkbox" className="mycheckbox"
										name="rawProduct"
										id="rawProduct"
										defaultChecked={true}
										checked={rawProduct}
										onChange={onResponseChange}
									/>
								</div>
								<div style={{ "display": "inline-block","marginLeft": "15px",  "marginRight": "10px" }}>
									<label htmlFor="finishedProduct" className="form-label">
										{t("page.prod.finish")}
									</label>
									<input type="checkbox" className="mycheckbox"
										name="finishedProduct"
										id="finishedProduct"
										defaultChecked={true}
										checked={finishedProduct}
										onChange={onResponseChange}
									/>
								</div>
								*/}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div id="placeholder_3" className="placeholder-pg"></div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-partner-close"
                                        id="edit-partner-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        disabled={isSubmit}
                                        onClick={(e) => handleClose()}
                                        style={{ marginRight: "50px" }}
                                        value={closeText}
                                    ></input>

                                    <div id="submit-spinner"
                                        className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                                    >  </div>
                                    <input
                                        type="submit"
                                        name="edit-submit"
                                        id="edit-submit"
                                        data-dismiss="modal"
                                        className={"btn btn-primary btn-block"}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={submitText}
                                        disabled={isSubmit}
                                    >
                                    </input>

                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mt-3">
                            {((formErrors && formErrors.length > 0) || error) ? (
                                <div id="berrorMessage" className="errorblock">
                                    {((formErrors && formErrors.length > 0)) ? (
                                        formErrors.map((errorData, index) => (
                                            <p className="message-line">{errorData}</p>
                                        ))
                                    ) : ""}
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg" style={{ height: "110px" }}></div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}

export default PartnerModal;